import { useState, useEffect, useRef } from 'react';

export const useTypingPlaceholder = ({ placeholders, delay = 100, pause = 1000 }) => {
    const [typedText, setTypedText] = useState('');
    const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);
    const directionRef = useRef(1); // Ref for typing direction (1 = forward, -1 = backward)
    const indexRef = useRef(0); // Current character index
    const intervalRef = useRef(null); // Ref for interval ID

    useEffect(() => {
        const currentText = placeholders[currentPlaceholderIndex];

        const startTyping = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            intervalRef.current = setInterval(() => {
                indexRef.current += directionRef.current;
                // Reverse direction if bounds are reached
                if (indexRef.current >= currentText.length) {
                    clearInterval(intervalRef.current); // Clear the current interval
                    setTimeout(() => {
                        directionRef.current = -1; // Start typing backward
                        startTyping(); // Re-start typing in the opposite direction
                    }, pause);
                } else if (indexRef.current < 0) {
                    clearInterval(intervalRef.current); // Clear the current interval
                    setTimeout(() => {
                        directionRef.current = 1; // Start typing forward
                        // Move to the next placeholder
                        setCurrentPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
                        indexRef.current = 0; // Reset index for the next word
                        startTyping(); // Re-start typing for the next word
                    }, pause);
                }
                // Update the displayed text
                setTypedText(currentText.slice(0, indexRef.current + 1));
            }, delay);
        };
        startTyping(); // Start the typing effect
        return () => {
            clearInterval(intervalRef.current); // Cleanup interval on unmount
        };
    }, [currentPlaceholderIndex, placeholders, delay, pause]); // Dependencies

    return typedText;
};
